import { FC, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Menu } from "../../ui-kit";
import menuStore from "../../store/menu";

const MenuComponent: FC = observer(() => {
  const { menuIsCollapsed } = menuStore;

  useEffect(() => {
    if (window.innerWidth < 1000) {
      menuIsCollapsed.setFalse();
    }
    menuStore.getMenu();
    return () => {
      menuStore.clearMenu();
    };
  }, []);

  return <Menu />;
});

export default MenuComponent;
